import { z } from 'zod';
export const UserRoleSchema = z.enum(['admin', 'sales']);
export const PaymentMethodSchema = z.enum(['cash', 'qr', 'card', 'other']);
//# sourceMappingURL=enums.js.map